import { useNode, useEditor } from "@craftjs/core";
import React, { useContext, useEffect, useLayoutEffect, useMemo } from "react";
import GrigoraCSSRenderer from "./../css-render";
import { TwitterSettings } from "./settings";
import icon from "./icon";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import IframeResizer from "iframe-resizer-react";
import { ResizableIframe } from "../../input";
import { isJsonString } from "../../helpers";
import { CMSTwitterSettings } from "./cms-settings";
import { APIProviderContext } from "../../api";
import { EmbedOverlay } from "../../block-helpers";
export const Twitter = (props) => {
  const {
    id,
    connectors: { connect, drag },
    actions: { setProp },
    selected,
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    actions: { selectNode },
  } = useEditor();
  const { getTweet } = useContext(APIProviderContext) ?? {};

  const { url, remoteTweetURL, tweet } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-twitter": true,
      [`twitter-${id}`]: id,
      "g-embed": true,
    },
    blockProps.className,
  );

  const html = useMemo(() => {
    if (isJsonString(tweet)) {
      return JSON.parse(tweet).html;
    }
    if (tweet?.html) {
      return tweet.html;
    }
    return "";
  }, [tweet]);

  useEffect(() => {
    if (!remoteTweetURL) return;
    getTweet?.(remoteTweetURL)
      .then((res) => {
        setProp((props) => {
          props.tweet = JSON.stringify(res.data.Output.message);
          props.url = remoteTweetURL;
          props.remoteTweetURL = null;
        });
      })
      .catch((error) => {
        // console.log(error);
      });
  }, [remoteTweetURL]);

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__Twitter(id, props)}`}</style>
      {tweet ? (
        <>
          <ResizableIframe className={"tweet-frame"} html={html} />
        </>
      ) : (
        <span className="empty-container">Add a Tweet</span>
      )}
      <EmbedOverlay id={id} selectNode={selectNode} selected={selected} />
    </div>
  );
};

// To Avoid Mangling in Production
Twitter.displayName = "Twitter";

Twitter.craft = {
  name: "Twitter",
  props: {},
  related: {
    CMSsettings: CMSTwitterSettings,
    settings: TwitterSettings,
    icon: icon,
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    keywords: ["Twitter"],
    category: "miscellaneous",
    isHiddenInPostEditor: true,
  },
  custom: {
    name: "Twitter",
    slug: "grigora/twitter",
  },
};
